import { twMerge } from 'tailwind-merge';
import blurText from '../helpers/blurText';

type Props = {
  children: string;
  isBlurred: boolean;
  className?: string;
};

export default function BlurText({ children, isBlurred, className }: Props) {
  return (
    <span className={twMerge(isBlurred ? 'blur-sm' : '', className)}>
      {blurText(children, isBlurred)}
    </span>
  );
}
